import React, { useState, useEffect, useMemo } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import axios from "axios";
import * as utils from "../../Utils/comman";
import DataTable from "react-data-table-component";
import CustomPagination from "../../Utils/CustomPagination";
import { DocumentDownload } from "iconsax-react";
import * as XLSX from "xlsx";

function AllEmpLeave() {
  const [leaveList, setLeaveList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );

  useEffect(() => {
    getAllEmpLeaveList();
  }, [page, filterText, selectedDate]);

  const getAllEmpLeaveList = () => {
    utils
      .callAPI(
        "get",
        `/leave/leave-request/leave-list-by-date?page=${page}&per_page=${countPerPage}&date=${
          selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : ""
        }`
      )
      .then((res) => {
        setLeaveList(res || []);
      })
      .catch(() => setLeaveList([]));
  };

  const columns = [
    {
      name: (
        <div>
          Employee Id <br />
        </div>
      ),
      selector: (row) => row.emp_code,
    },
    {
      name: "Employee Name",
      selector: (row) => row.employee_name,
    },

    // {
    //   name: "Start Date",
    //   selector: (row) => moment(row.start_date).format("DD-MM-YYYY"),
    // },
    // {
    //   name: "End Date",
    //   selector: (row) => moment(row.end_date).format("DD-MM-YYYY"),
    // },
    {
      name: "Leave Day",
      selector: (row) => {
        if (row.leave_day === "full") {
          return "Full Day";
        } else if (row.leave_day === "first_half") {
          return "First Half";
        } else if (row.leave_day === "second_half") {
          return "Second Half";
        }
        return "Unknown"; // Fallback for unexpected values
      },
    },
    
    {
      name: "Leave Type",
      selector: (row) => row.leave_name,
    },
    {
      name: "Status ",
      selector: (row) => getStatusName(row.status),
    },
  ];

  const getStatusName = (status) => {
    switch (status) {
      case "0":
        return "Pending";
      case "1":
        return "Reject";
      case "2":
        return "Approved";
      case "3":
        return "Cancel";
      default:
        return "Unknown";
    }
  };

  const handleDownload = () => {
    const csvHeader = "Sr.No.,Employee ID,Employee Name,Leave Day,Leave Type,Status";
    const csvRows = leaveList?.result?.map((leave, index) => {
      const leaveDay =
        leave.leave_day === "full"
          ? "Full Day"
          : leave.leave_day === "first_half"
          ? "First Half"
          : leave.leave_day === "second_half"
          ? "Second Half"
          : "Unknown";
  
      return `${index + 1},${leave.emp_code},${leave.employee_name},${leaveDay},${leave.leave_name},${getStatusName(leave.status)}`;
    });
  
    const csvContent = [csvHeader, ...csvRows].join("\n");
    generateCSV(csvContent, "AllEmpLeaveData.csv");
  };
  

  function generateCSV(filteredData, fileName) {
    const blob = new Blob([filteredData], { type: "text/csv;charset=utf-8;" });
  
    // Create a temporary download link
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
  
    // Append the link to the body temporarily and trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <RB.Row>
      <RB.Card>
        <RB.Card.Header>
          <h4>Employees On Leave</h4>
          <div className="card-header-action">
            <RB.Button
              size="sm"
              variant="primary"
              className="btn-circle"
              onClick={handleDownload}
              disabled={leaveList?.result?.length == 0}
            >
              {/* <ArrowDown /> */}
              <DocumentDownload />
            </RB.Button>
          </div>
        </RB.Card.Header>

        <RB.Card.Body>
          <RB.Row className="mb-3 justify-content-end">
            <RB.Col className="col-md-4 col-12 m-0">
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                placeholderText="Select Date"
                className="form-control"
                maxDate={new Date()}
                dateFormat="dd-MM-yyyy"
              />
            </RB.Col>
          </RB.Row>

          <DataTable
            columns={columns}
            data={leaveList.result}
            highlightOnHover
            responsive
            pagination
            paginationServer
            paginationTotalRows={leaveList.total}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            paginationComponent={() => (
              <CustomPagination
                currentPage={page}
                totalRows={leaveList.total}
                rowsPerPage={countPerPage}
                onPageChange={(newPage) => setPage(newPage)}
              />
            )}
            striped
            onChangePage={(page) => setPage(page)}
            persistTableHead
            customStyles={{
              head: {
                style: {
                  fontSize: "0.875rem", // Adjust the font size as needed
                  fontWeight: "bold", // Adjust the font weight as needed
                },
              },
            }}
          />
        </RB.Card.Body>
      </RB.Card>
    </RB.Row>
  );
}

export default AllEmpLeave;
